import { useEffect } from 'react'

export type CommonTaskUIPropsType = {
    keyBindingActions: (event: KeyboardEvent) => void
    children?: React.ReactNode
}

export const CommonTaskUI = (props: CommonTaskUIPropsType) => {
    useEffect(() => {
        window.addEventListener('keydown', props.keyBindingActions)

        return () => {
            window.removeEventListener('keydown', props.keyBindingActions)
        }
    }, [props.keyBindingActions])

    return <>{props.children}</>
}
